import Vue from "vue";
import VueRouter from "vue-router";
import layout from '../views/layout/index'
import phone from '../views/phone/index'
Vue.use(VueRouter);

//添加以下代码
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
        return originalPush.call(this, location).catch(err => err)
}
    //默认路由
export const routes = [{
    path: "/",
    name: 'layout',
    component: layout,
    redirect: '/home_p',
    children: [{
            path: "/home_p",
            name: 'home_p',
            meta: { title: '首页' },
            component: () =>
                import ('@/views/home/home_pc.vue')
        },
        {
            path: "/about_p",
            name: 'about_p',
            meta: { title: '关于我们' },
            component: () =>
                import ('@/views/about/about_pc.vue'),
            redirect: '/about/overview_p',
            children: [{
                path: "/about/overview_p",
                name: 'overview_p',
                component: () =>
                    import ('@/views/about/overview_pc.vue')
            }, {
                path: "/about/enterprise_p",
                name: 'enterprise_p',
                component: () =>
                    import ('@/views/about/enterprise_pc.vue')
            }]

        },
    ]
}, {
    path: "/home",
    name: 'home',
    component: phone,
    redirect: '/home',
    children: [{
            path: "/home",
            name: 'home',
            meta: { title: '首页' },
            component: () =>
                import ('@/views/home/home.vue')
        },
        {
            path: "/about",
            name: 'about',
            meta: { title: '关于我们' },
            component: () =>
                import ('@/views/about/about.vue'),
            redirect: '/about/overview',
            children: [{
                path: "/about/overview",
                name: 'overview',
                component: () =>
                    import ('@/views/about/overview.vue')
            }, {
                path: "/about/enterprise",
                name: 'enterprise',
                component: () =>
                    import ('@/views/about/enterprise.vue')
            }]

        },
    ]
}, ];


const router = new VueRouter({
    routes, // (缩写) 相当于 routes: routes
    // 当路由跳转后滚动条所在的位置
    scrollBehavior(to, from, savedPosition) {
        // return 期望滚动到哪个的位置
        return { x: 0, y: 0 } // x控制左右，y控制上下
    }
})

export default router;